import BaseRecordDialog from 'modules/pond/components/BaseRecordDialog'
import { useState } from 'react'
import { useTranslation } from 'react-i18next'

import ShrimpSalesForm from '../ShrimpSalesForm'
import { ShrimpSales } from 'modules/shrimpSales/api/types'
import { useSpeciesName } from 'modules/pond/api/selector'

interface ShrimpSalesRecordDialogProps {
  open: boolean
  onClose: () => void
  data?: ShrimpSales // <== ถ้ามีคือ edit, ถ้าไม่มีคือ create
}

const ShrimpSalesRecordDialog = ({ onClose, open, data }: ShrimpSalesRecordDialogProps) => {
  const { t } = useTranslation('shrimpSales')
  const [submitting, setSubmitting] = useState(false)
  const [step, setStep] = useState<1 | 2>(1)
    const speciesName = useSpeciesName()

  const onStartLoading = () => {
    setSubmitting(true)
  }

  const onStopLoading = () => {
    setSubmitting(false)
  }

  const handleClose = () => {
    setStep(1)
    onClose()
  }

  const formId = data
    ? `edit-shrimp-sales-${data.id}`
    : 'create-shrimp-sales'

  return (
    <BaseRecordDialog
      onClose={onClose}
      open={open}
      formId={step === 2 ? formId : ''}
      title={t('dialog.title', {speciesName})}
      isSubmitting={submitting}
      hideActions
      maxWidth="md"
      fullWidth
    >
      <ShrimpSalesForm
        data={data}
        onCancel={handleClose}
        onSubmitSuccess={() => {
          onStopLoading()
          handleClose()
        }}
        onSubmitFinally={() => {
          onStopLoading()
        }}
        onSubmitFailed={() => {
          onStopLoading()
        }}
        onSubmitForm={() => {
          onStartLoading()
        }}
        isDialog
        step={step}
        onChangeStep={setStep}
      />
    </BaseRecordDialog>
  )
}

export default ShrimpSalesRecordDialog
